import { createTranslations } from '@momentum/i18n';
import { userSelectorEnTranslations } from './user-selector.en';

export const userSelectorHeTranslations = createTranslations(
  userSelectorEnTranslations,
  {
    // Search and selection
    searchPlaceholder: 'חפש עובד',
    noEmployeesFound: 'לא נמצאו עובדים התואמים לחיפוש',
    noEmployeesAvailable: 'אין עובדים זמינים',

    // Selection actions
    selectAll: 'בחר/י הכל',
    clearAll: 'נקה הכל',
    allSelected: 'הכל נבחר',
    selectOptions: 'בחר/י אפשרויות',

    // Actions
    continue: 'המשך',

    // Validation messages
    pleaseSelectAtLeast: (count: number, type: string) =>
      `אנא בחר לפחות ${count} ${type}`,
    employee: 'עובד',

    // Selection count with proper pluralization (RTL-friendly word order)
    selectionCount: (count: number) =>
      count === 1 ? `עובד ${count} נבחר` : `עובדים ${count} נבחרו`,

    // Assignees specific
    assigneesLabel: 'עובדים',
    assigneesDescription: 'בחר עובדים להקצות את המטרה הזו',
    selectAssignees: 'בחר עובדים',

    // Team member badge
    teamMember: 'חבר צוות',
  }
);
